import type { IconSvgObject } from './types';

const VrIcon: IconSvgObject = [
  ["path", { d: "M5 6H7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 17L12 18.9909L10 21M15 19C18.5 18.5 21 17 22 15M2 15C3 17 6.5 19 11.5104 18.9909", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 10V6C2 4.34315 3.34315 3 5 3H19C20.6569 3 22 4.34315 22 6V10C22 11.6569 20.6569 13 19 13H15.9051C15.0148 13 14.1704 12.6045 13.6005 11.9206L12 10L10.3995 11.9206C9.82956 12.6045 8.98521 13 8.09488 13H5C3.34315 13 2 11.6569 2 10Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default VrIcon;
